var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-search",class:_vm.classes},[_c('search-icon'),_vm._v(" "),_c('input',{attrs:{"id":_vm.id,"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }